export enum ShipmentStatus {
  Canceled = 'Canceled',
  Delayed = 'Delayed',
  Delivered = 'Delivered',
  InTransit = 'InTransit',
  Booked = 'Booked',
  OnTime = 'OnTime',
}
